export default "__VITE_ASSET__DzfJySvT__"